import React, { useState, useEffect, useRef } from 'react';
import importAllImg from "../helpers/import-all-imgs";
import {useIntl} from "react-intl";

const imgs = importAllImg(require.context('../img/npf', false, /\.(png|jpe?g|svg)$/));


function InspiringVietnam() {

  const { formatMessage, locale } = useIntl();
  const fm = id => formatMessage({id});

  const partnerships = [
    {
      titleKey: 'Fulbright University Vietnam',
      logo: 'image 2300.png',
      url: 'https://fulbright.edu.vn/'
    },
    {
      titleKey: 'Li Foundation',
      logo: 'Li Foundation.png',
      url: 'https://www.lifoundationsg.com/'
    },
    {
      titleKey: 'A.D.A Productions',
      logo: 'Ai.Dream_.Art_logo-vbk.png',
      url: 'https://adartsg.com/'
    },
    {
      titleKey: 'Bluehill',
      logo: 'image 2315.png',
      url: 'https://bluehillsingapore.org/'
    },
    {
      titleKey: 'Enlight Foundation',
      logo: 'image 2316.png',
      url: 'https://www.enlightfoundation.org/'
    },
    {
      titleKey: 'Rockefeller Brothers Fund',
      logo: 'image 2317.png',
      url: 'https://www.rbf.org/'
    },
    {
      titleKey: 'Asia Community Foundation',
      logo: '1673845777755-removebg-preview 1.png',
      url: 'https://www.asiacf.org/'
    },
    {
      titleKey: 'Asia Philanthropy Circle',
      logo: 'image 2320.png',
      url: 'https://asiaphilanthropycircle.org/'
    }
  ];

  const isMobile = window.innerWidth <= 991;

  return (
    <>
      <div className='mt-14 md:mt-24 relative'>
        <img className='hidden md:block w-full' src={imgs['Group 3024.png']}/>
        <img className='md:hidden block w-full' src={imgs['Group 3023 (1).png']}/>

        <div
          className='w-[227px] md:w-[600px] text-center absolute text-lg md:text-5xl font-bold text-white z-1 md:leading-[1.2] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
          {
            locale === 'en' ? 'Honoring the spirit of Vietnam through stories, arts, and the creativity of its people' :
              'Tôn vinh tinh thần Việt Nam thông qua những câu chuyện, nghệ thuật và sức sáng tạo của con người'
          }
        </div>
      </div>

      <div className='bg-white py-4 md:py-10 px-5 md:px-[7.5%]'>
        <div className='text-center mb-2 md:mb-3'>
          <h2 className='text-sm md:text-xl font-bold uppercase'>
            {fm('INSPIRING VIETNAM')}
          </h2>
        </div>
        <div className='max-w-[90%] md:max-w-2xl mx-auto'>
          <p className='text-base text-black md:text-2xl leading-relaxed text-center'>
            {fm('Highlighting unheard voices and untold stories, we strive to increase participation and representation, ensuring these vital narratives contribute to social change')}
          </p>
        </div>
      </div>

      <div className='block md:hidden'>
        <img src={imgs['image 2321.png']} className='w-full'/>
      </div>
      <div className='bg-white py-2 md:py-10 px-8 md:px-[7.5%]'>
        <h2 className='text-xl md:text-3xl font-bold mb-2 md:mb-4 text-black'>
          {fm('About Inspiring Vietnam')}
        </h2>
        <div className='flex flex-col md:flex-row gap-8 md:gap-24 items-start'>
          {/* Text Section - Left */}
          <div className='flex-1 md:flex-[2]'>

            <div className='space-y-4 md:space-y-6 text-base md:text-lg leading-relaxed text-black'>
              <p>
                {
                  locale === 'en' ? <>
                    <b>Inspiring Vietnam</b>, part of <b>Inspiring Asia</b>, is a Micro-Film Festival that aims to
                    showcase the power of storytelling for social impact. This Festival will bring together filmmakers,
                    foundations, organizations and Universities to present stories that inspire action, raise awareness
                    and spark meaningful dialogue.
                  </> : <>
                    <b>Inspiring Vietnam</b>, một phần của <b>Inspiring Asia</b>, là <b>Cuộc Thi Phim Ngắn</b> nhằm tôn
                    vinh sức mạnh của kể chuyện trong việc tạo tác động xã hội. Cuộc thi quy tụ các nhà làm phim, quỹ,
                    tổ chức và trường đại học để giới thiệu những câu chuyện có khả năng khơi gợi hành động, nâng cao
                    nhận thức và mở ra những cuộc đối thoại ý nghĩa.
                  </>
                }
              </p>
              <p>
                {fm('Inspiring Asia is a unique platform dedicated to amplifying the voices and stories that showcases Asia’s diverse cultures, innovative spirit, and commitment to positive change. It empowers the young generation to shed light on social, environmental, and community challenges, while celebrating the love, determination, and aspirations that defines the Asian spirit.')}
              </p>

              <p>
                {fm('Each year, the festival will call for submissions based on the themes presented by Inspiring Asia. This will culminate in a film festival in Vietnam to showcase the finalist entries before being considered for the Grand Final in Singapore for Inspiring Asia.')}
              </p>

              <p>
                {fm("Join us, share your film and let’s showcase the power of storytelling for good.")}
              </p>

            </div>
          </div>
          {/* Image Section - Right */}
          <div className='flex-1 md:flex-[1] w-full md:w-auto hidden md:block'>
            <img
              src={imgs['Group 3025 (1).png']}
              alt="Who We Are"
              className='w-full h-auto object-cover'
            />
          </div>
        </div>
      </div>

      {/*Inspiring Vietnam CTA Section*/}
      <div className='relative bg-white py-2 md:py-10 px-8 md:px-[7.5%]'>
        {/* Background Image */}
        <img
          src={imgs['Group 3027.png']}
          alt="Inspiring Vietnam"
          className='w-full h-auto object-cover hidden md:block'
        />

        <img src={imgs['Group 3031.png']} className='block md:hidden w-full' />

        {/* Overlay with Content */}
        <div className='absolute z-1 top-[12%] md:top-[20%] left-[12%] md:left-[10%] flex items-center'>
          {/* Left Section - Dark Green Overlay */}
          <div>
            <h2 className='text-base md:text-4xl font-bold text-white mb-2 md:mb-6'>
              {fm('Inspiring Vietnam')}
            </h2>
            <p className='text-sm md:text-xl text-white leading-tight md:leading-relaxed mb-6 md:mb-8 whitespace-pre-line'>
              {fm('Stories that Illuminate, \nSolutions that Empower')}
            </p>
            <button
              onClick={() => window.open('https://www.inspiringvietnam.org/', '_blank')}
              className='h-[22px] md:h-[auto] md:mt-[200px] md:w-[350px] font-bold bg-white text-[#354402] py-1 px-3 md:px-6 md:py-3 rounded-lg text-[11px] md:text-base hover:opacity-90 transition-opacity flex items-center justify-center gap-2'
            >
              {fm('VISIT WEBSITE')}
              <span className='text-lg -mt-1 md:mt-auto'>→</span>
            </button>
          </div>
        </div>
      </div>

      {/*Partnerships*/}
      <div className='bg-white py-4 md:py-10 px-5 md:px-[7.5%]'>
        <h2 className='text-lg md:text-3xl font-bold text-center mb-4 md:mb-12 text-black'>
          {fm('PARTNERSHIPS')}
        </h2>

        {/* Desktop Grid */}
        <div className='hidden md:grid md:grid-cols-3 gap-x-8 gap-y-8'>
          {partnerships.map((partnership, index) => (
            <div
              key={index}
              className='bg-[#F2F2F7] rounded-2xl border border-gray-200 overflow-hidden flex flex-col'
            >
              {/* Content */}
              <div className='p-6 flex-1 flex flex-col items-center text-center'>
                {/* Logo */}
                <div className='mb-4 h-20 flex items-center justify-center'>
                  <img
                    src={imgs[partnership.logo]}
                    alt={fm(partnership.titleKey)}
                    className='max-h-20 w-auto object-contain'
                  />
                </div>

                {/* Title */}
                <h3 className='text-lg font-bold mb-4 text-black uppercase'>
                  {fm(partnership.titleKey)}
                </h3>
              </div>

              {/* Learn More Button */}
              {partnership.url && (
                <button
                  onClick={() => window.open(partnership.url, '_blank')}
                  className='uppercase w-full bg-[#354402] text-white px-4 py-2 rounded-bl-lg rounded-br-lg text-sm font-semibold hover:bg-[#2a3501] transition-colors flex justify-center items-center gap-2'
                >
                  {fm('Learn more →')}
                </button>
              )}
            </div>
          ))}
        </div>

        {/* Mobile List */}
        <div className='block md:hidden space-y-3'>
          {partnerships.map((partnership, index) => (
            <div
              key={index}
              onClick={() => partnership.url && window.open(partnership.url, '_blank')}
              className={`bg-[#F2F2F7] h-[51px] flex items-stretch ${partnership.url ? 'cursor-pointer' : ''}`}
              style={{ borderRadius: '12px 0 0 12px', overflow: 'hidden' }}
            >
              {/* Colored Block - Leftmost with rounded corners */}
              <div
                className={`w-[50px] flex-shrink-0 bg-[#D2E3AA] rounded-tl-[12px] rounded-bl-[12px]`}
              ></div>

              {/* Title */}
              <div className='flex-1 px-4 py-4 flex items-center'>
                <h3 className='text-sm font-bold text-black uppercase leading-tight mb-0'>
                  {fm(partnership.titleKey)}
                </h3>
              </div>

              {/* Arrow Icon */}
              {partnership.url && (
                <div className='pr-4 flex-shrink-0 flex items-center'>
                  <img
                    src={imgs['arrow-down-right-svgrepo-com 14.svg']}
                    alt="Learn more"
                    className='w-5 h-5'
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/*poster part*/}
      {/* Top Part - Title and Video */}
      <div className='bg-[#F5F4EE] py-2 md:py-5 px-5 md:px-[7.5%]'>
        {/* Title and Subtitle */}
        <h1 className='text-2xl md:text-4xl font-bold text-black mb-2'>
          {fm('Ripples of Kindness: The Power of Paying it Forward')}
        </h1>
        <p className='text-base md:text-lg font-bold text-black mb-6 md:mb-8'>
          {fm('A Nguyen-Phuong Family Foundation Film')}
        </p>

        {/* Video */}
        <div className='mb-8 md:mb-12'>
          <div className='w-full flex justify-center'>
            <iframe width={isMobile? 297: 792} height={isMobile? 157: 538} src="https://www.youtube.com/embed/Hn_xETZc_rE"
                    title="Ripples of Kindness: The Power of Paying It Forward" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
          </div>
        </div>
      </div>

      {/* Bottom Part - Two Column Layout */}
      <div className='bg-[#F5F4EE] py-2 md:py-5 px-5 md:px-[7.5%]'>
        <div className='flex flex-col md:flex-row  gap-2 md:gap-16 justify-between'>
          {/* Left Side - Description */}
          <div className='flex-1 md:flex-[2]'>
            {/* Synopsis */}
            <div className='mb-6 md:mb-8'>
              <h2 className='text-xl md:text-2xl font-bold text-black mb-4'>
                {fm('Synopsis:')}
              </h2>
              <div className='space-y-4 text-base md:text-lg leading-relaxed text-black'>
                <p>
                  {fm('When we give selflessly without expectation, a single act of kindness can set off a ripple of positive changes beyond our wildest hopes. Ripples of Kindness is a beautiful story that demonstrates the impact of paying-it-forward and the powerful force of philanthropy guided by the spirit.')}
                </p>
                <p>
                  {fm('The film follows the story of one man\'s decision to create a scholarship that would unknowingly spark a chain of generosity that creates a movement in his native Vietnam.')}
                </p>
                <p>
                  {fm('A scholarship recipient, inspired by the opportunity she received, establishes a social impact organisation - VietSeeds Foundation. VietSeeds not only provides Vietnamese youth with scholarships, but cultivates the next generation of leaders to become changemakers in their communities through Inner Transformation.')}
                </p>
                <p>
                  {fm('The ripple effect continues when one of the co-founder\'s of VietSeeds, deeply influenced by the power of mindfulness, goes on to co-found Heart and Mind Education with other partners. This initiative aims to provide Vietnamese educators with the tools to foster emotional, social, and ethical intelligence in students. We cannot achieve much alone. To create something truly sustainable, we must each contribute our thread and trust in humanity to weave together a tapestry of positive change. Grow a seed, change a life, and transform a nation.')}
                </p>
              </div>
            </div>

            {/* Call to Action */}
            <div className='mb-6 md:mb-8'>
              <p className='text-lg md:text-xl text-black'>
                {locale === 'en' ? (
                  <>How will you start your <b>Ripple Effect of Kindness</b>?</>
                ) : (
                  <>Bạn sẽ bắt đầu <b>làn sóng lan tỏa sự tử tế</b> của chính mình như thế nào?</>
                )}
              </p>
            </div>

            {/* Credits */}
            <div className='mb-6 md:mb-8'>
              <h3 className='text-lg md:text-xl underline text-black mb-1'>
                {fm('Our credit and special thanks to:')}
              </h3>
              <div className='space-y-1 text-base md:text-lg text-black'>
                <p className='mb-0'>
                  {locale === 'en' ? (
                    <><b>Van Dinh Hong Vu</b> (Co-Founder, VietSeeds Foundation)</>
                  ) : (
                    <>{fm('Van Dinh Hong Vu (Co-Founder, VietSeeds Foundation)')}</>
                  )}
                </p>
                <p>
                  {locale === 'en' ? (
                    <><b>Huyen Ton Nu Cat Tuong</b> (Co-Founder, VietSeeds Foundation)</>
                  ) : (
                    <>{fm('Huyen Ton Nu Cat Tuong (Co-Founder, VietSeeds Foundation)')}</>
                  )}
                </p>
                <p>
                  {locale === 'en' ? (
                    <><b>Tran Thi Minh Trang</b> (Co-Founder of Heart & Mind Education)</>
                  ) : (
                    <>{fm('Tran Thi Minh Trang (Co-Founder of Heart & Mind Education)')}</>
                  )}
                </p>
                <p>
                  {locale === 'en' ? (
                    <><b>Nguyen Duc Thuy Anh</b> (Co-Founder, VietSeeds Foundation and Heart & Mind Education)</>
                  ) : (
                    <>{fm('Nguyen Duc Thuy Anh (Co-Founder, VietSeeds Foundation and Heart & Mind Education)')}</>
                  )}
                </p>
                <p>
                  {locale === 'en' ? (
                    <><b>Director:</b> Tam Bui | Chi Lai</>
                  ) : (
                    <>{fm('Director: Tam Bui | Chi Lai')}</>
                  )}
                </p>
                <p>
                  {locale === 'en' ? (
                    <><b>Producer:</b> Chi Lai | Jeremy Nguyen Phuong</>
                  ) : (
                    <>{fm('Producer:  Chi Lai | Jeremy Nguyen Phuong')}</>
                  )}
                </p>
              </div>
            </div>
          </div>

          {/* Right Side - Poster and Icons */}
          <div>
            <div className='md:block flex flex-row-reverse justify-between items-start'>
              {/* Poster */}
              <img
                src={imgs['image 2311.png']}
                alt="Ripples of Kindness Poster"
                className='w-[123px] md:w-[329px] h-auto object-contain mb-6 md:mb-8'
              />

              <div>
                {/* Film Details */}
                <div className='mb-2 md:mb-8'>
                  <div className='space-y-1 text-sm md:text-lg text-black'>
                    <p className='mb-0'>
                      <span className='font-bold'>{fm('Year:')}</span> 2024
                    </p>
                    <p>
                      <span className='font-bold'>{fm('Country of Origin:')}</span> {locale === 'en' ? 'Vietnam' : 'Việt Nam'}
                    </p>
                    <p>
                      <span className='font-bold'>{fm('Language:')}</span> {locale === 'en' ? 'English and Vietnamese' : 'Tiếng Anh và tiếng Việt'}
                    </p>
                  </div>
                </div>

                {/* Organizations Presented */}
                <div>
                  <h3 className='text-base md:text-xl font-bold text-black mb-4'>
                    {fm('Organizations Presented:')}
                  </h3>
                  <div className='flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6'>
                    <img
                      className='w-[154px] md:w-[auto]'
                      src={imgs['vietseeds 1.png']}
                      alt="VietSeeds Foundation"
                    />
                    <img
                      className='w-[62px] md:w-[auto]'
                      src={imgs['HME_Logo-removebg-preview 1.png']}
                      alt="Heart & Mind Education"
                    />
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </div>

      {/* bottom part - Quote section */}
      <div className='relative -mb-1 md:mb-auto md:py-20 px-5 md:px-10 h-[150px] md:h-[400px] flex items-center justify-end'>
        <img
          src={imgs['Group 30091.png']}
          alt="Quote Background"
          className='absolute inset-0 w-full h-[150px] md:h-auto'
        />
        <div className='relative mt-0 z-10 max-w-[205px] md:max-w-2xl mx-auto'>
          <div className='text-xs md:text-2xl font-bold text-black leading-[1.3] md:leading-relaxed text-center'>
            {
              locale === 'en' ?
                <>
                  A person has ancestors just as a tree has roots and a river has its source
                </> :
                <>
                  Con người có tổ tiên, cũng như cây có rễ và sông có nguồn.
                </>
            }
          </div>
        </div>
      </div>

    </>
  )
}

export default InspiringVietnam;
